export default "__VITE_ASSET__Dou20Nr0__"